import { Modal, Button, Form } from "react-bootstrap";
import "./modalIndicouGanhou.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../../config/FirebaseConfig";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";

export const ModalIndicouGanhou = ({ show, onHide, currentPanel }) => {
  const navigate = useNavigate();
  const [linkParceiro, setLinkParceiro] = useState("");
  const [linkCliente, setLinkCliente] = useState("");

  useEffect(() => {
    if (show && currentPanel) {
      const fetchLinks = async () => {
        const carouselCollection = collection(db, "carousel");
        const data = await getDocs(carouselCollection);
        const carouselData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        }));
        const filteredData = carouselData.filter((item) => item.panel === currentPanel);
        if (filteredData.length > 0) {
          setLinkParceiro(filteredData[0].linkParceiro || "");
          setLinkCliente(filteredData[0].linkCliente || "");
        }
      };
      fetchLinks();
    }
  }, [show, currentPanel]);

  const handleClose = () => {
    if (onHide) onHide();
  };

  const handleParceiros = () => {
    if (linkParceiro) {
      window.open(linkParceiro, "_blank");
    } else {
      console.log("Parceiros clicked - no link available");
    }
    handleClose();
  };

  const handleClientes = () => {
    if (linkCliente) {
      window.open(linkCliente, "_blank");
    } else {
      console.log("Clientes clicked - no link available");
    }
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title className="modal-title-custom">
          Campanha <span className="modal-title-highlight">Indicou e Ganhou</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body-custom">
        <p className="modal-description">
          Escolha uma das opções abaixo para participar da nossa campanha:
        </p>
        <div className="modal-buttons-container">
          <Button
            className="modal-button parceiros-button"
            onClick={handleParceiros}
          >
            Parceiros
          </Button>
          <Button
            className="modal-button clientes-button"
            onClick={handleClientes}
          >
            Clientes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
